if(!customElements.get('hero-slider')) {
  class HeroSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", e => {
          this.mountSlider();
        });
      }

      this.mountSlider();

      window.addEventListener("shopify:block:select", e => {
        const selectedSlideIndex = +e.target.dataset.index;
        this.slider.slideTo(selectedSlideIndex, 600);
      });
      this.lastActiveIndex = null;
      this._heroFullyVisible = true;
      this._lastSlideReachedAt = 0;
      this._lastSlideHoldMs = 1000;
      this.addKeyboardNavigation();
      if (this.dataset.paginationStyle === "style-3") {
        this._observeHeroVisibility();
        this._bindWheelGuard();
      }
    }

    _observeHeroVisibility() {
      if (typeof IntersectionObserver === "undefined") return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this._heroFullyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.99;
          });
        },
        { threshold: [0, 0.99, 1], rootMargin: "0px" }
      );
      observer.observe(this);
    }

    _bindWheelGuard() {
      const onWheel = (e) => {
        if (!this.slider) return;
        if (!this._heroFullyVisible) {
          e.stopPropagation();
        }
      };
      document.addEventListener("wheel", onWheel, { passive: true, capture: true });

      const onWheelLastSlideHold = (e) => {
        if (!this.slider || e.deltaY <= 0) return;
        const isLastSlide = this.slider.activeIndex === this.slider.slides.length - 1;
        const withinHold = this._lastSlideReachedAt && (Date.now() - this._lastSlideReachedAt) < this._lastSlideHoldMs;
        if (this._heroFullyVisible && isLastSlide && withinHold) {
          e.preventDefault();
          e.stopPropagation();
        }
      };
      document.addEventListener("wheel", onWheelLastSlideHold, { passive: false, capture: true });
      this.addEventListener("wheel", onWheelLastSlideHold, { passive: false, capture: false });
      document.addEventListener("wheel", onWheelLastSlideHold, { passive: false, capture: false });
    }

    mountSlider() {
      const isScrollVertical = this.dataset.paginationStyle === "style-3";
      const autoplayOptions = {
        delay: this.dataset.autoplayInterval
      };

      const interleaveOffset = 0.75;

      const baseOptions = {
        rewind: true,
        slidesPerView: 1,
        speed: isScrollVertical ? 1000 : 900,
        followFinger: isScrollVertical,
        ...(!isScrollVertical && {
          effect: "fade",
          fadeEffect: { crossFade: true }
        }),
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev"
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (i, className) {
            return `
            <button class="${className}">
              <span>0${i + 1}</span>
              <svg class="square-progress" width="26" height="26">
                <rect class="square-origin" width="26" height="26" rx="5" ry="5" />
              </svg>
              <svg class="progress" width="18" height="18" style="inset-inline-start: ${
                0 - (i * 2.4 + 3.4)
              }rem">
                <circle class="circle-origin" r="8" cx="9.5" cy="9.5"></circle>
              </svg>
            </button>
            `;
          }
        },
        autoplay:
          !isScrollVertical && this.dataset.autoplay === "true"
            ? autoplayOptions
            : false,
        on: {
          init: this.handleSlideChange.bind(this),
          slideChange: this.handleSlideChange.bind(this)
        }
      };

      if (isScrollVertical) {
        baseOptions.direction = "vertical";
        baseOptions.speed = 800;
        baseOptions.mousewheel = { releaseOnEdges: true };
        baseOptions.touchReleaseOnEdges = true;
        baseOptions.watchSlidesProgress = true;
        baseOptions.on.progress = function (swiper) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slideProgress = swiper.slides[i].progress;
            const isActive = swiper.activeIndex === i;
            const innerTranslate = isActive ? 0 : slideProgress * swiper.height * interleaveOffset;
            const inner = swiper.slides[i].querySelector(".hero__inner");
            if (inner) {
              inner.style.transform = `translate3d(0, ${innerTranslate}px, 0)`;
            }
          }
        };
        baseOptions.on.setTransition = function (swiper, speed) {
          const easing = "cubic-bezier(0.33, 1, 0.68, 1)";
          for (let i = 0; i < swiper.slides.length; i++) {
            swiper.slides[i].style.transition = `transform ${speed}ms ${easing}`;
            const inner = swiper.slides[i].querySelector(".hero__inner");
            if (inner) {
              inner.style.transition = `transform ${speed}ms ${easing}`;
            }
          }
        };
      } else {
        baseOptions.followFinger = false;
        baseOptions.watchSlidesProgress = true;
        const parallaxOffset = 0.12;
        baseOptions.on.progress = function (swiper) {
          for (let i = 0; i < swiper.slides.length; i++) {
            const slideProgress = swiper.slides[i].progress;
            const isActive = swiper.activeIndex === i;
            const innerTranslate = isActive ? 0 : slideProgress * swiper.width * parallaxOffset;
            const inner = swiper.slides[i].querySelector(".hero__inner");
            if (inner) {
              inner.style.transform = `translate3d(${innerTranslate}px, 0, 0)`;
            }
          }
        };
        baseOptions.on.setTransition = function (swiper, speed) {
          const easing = "cubic-bezier(0.33, 1, 0.68, 1)";
          for (let i = 0; i < swiper.slides.length; i++) {
            const inner = swiper.slides[i].querySelector(".hero__inner");
            if (inner) {
              inner.style.transition = `transform ${speed}ms ${easing}`;
            }
          }
        };
      }

      this.slider = new Swiper(this, baseOptions);
    }

    handleSlideChange(swiper) {
      if (swiper.slides.length && swiper.activeIndex === swiper.slides.length - 1) {
        this._lastSlideReachedAt = Date.now();
      }
      this.handleSlideChangeAnimations(swiper);

      let headerInner = document.querySelector(".header__inner");
      let heroInners = document.querySelectorAll(".hero__inner");

      if (!headerInner || !heroInners) {
        return;
      }

      document.documentElement.style.setProperty(
        "--transparent-header-menu-text-color",
        heroInners[swiper.activeIndex].dataset.headerMenuTextColor
      );
    }

    handleSlideChangeAnimations(swiper) {
      let delay = 300;
      const queryElement = `[data-index="${swiper.activeIndex}"]`;
      const queryArray = [
        ...swiper.wrapperEl.querySelector(queryElement).querySelectorAll('.hero__animation') || []
      ];
      if (!queryArray.length) {
        return;
      }
      const isMobile = window.innerWidth < 750;
      const allowMobileAnimation =
        swiper.wrapperEl.closest(".hero__content")?.dataset
          .animationMobile === "true";
      if (!allowMobileAnimation && isMobile) {
        queryArray.forEach((element) => {
          element.classList.remove('in-delay');
        });
        return;
      }
      queryArray.forEach((element) => {
        element.classList.add('in-delay');
      });

      const isFadeEffect = this.dataset.paginationStyle !== "style-3" && swiper.params.effect === "fade";
      if (this.lastActiveIndex > swiper.activeIndex) {
        delay = 650 + delay;
        if (!isFadeEffect) {
          swiper.wrapperEl.style.transitionDuration = '900ms';
          swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.33, 1, 0.68, 1)';
        }
      } else if (this.lastActiveIndex < swiper.activeIndex) {
        delay = 1000 + delay;
        if (!isFadeEffect) {
          swiper.wrapperEl.style.transitionDuration = '900ms';
          swiper.wrapperEl.style.transitionTimingFunction = 'cubic-bezier(0.33, 1, 0.68, 1)';
        }
      }

      setTimeout(() => {
        if (this.lastActiveIndex > swiper.activeIndex) {
          delay = 325 + delay;
        } else if (this.lastActiveIndex < swiper.activeIndex) {
          delay = 500 + delay;
        }
        queryArray.forEach((element, index) => {
          if (index === 1) {
            delay = delay + 50;
          } else if (index === 2) {
            delay = delay + 175;
          } else if (index === 3) {
            delay = delay + 300;
          }
          element.classList.remove("in-delay");
        });
      }, delay);

      this.lastActiveIndex = swiper.activeIndex;
    }
    addKeyboardNavigation() {
      const isVertical = this.dataset.paginationStyle === "style-3";
      document.addEventListener("keydown", event => {
        if (this.isInViewport()) {
          const nextKey = isVertical ? "ArrowDown" : "ArrowRight";
          const prevKey = isVertical ? "ArrowUp" : "ArrowLeft";
          if (event.key === nextKey) {
            const nextButton = this.querySelector(".swiper-button--next");
            if (nextButton) nextButton.click();
          }
          if (event.key === prevKey) {
            const prevButton = this.querySelector(".swiper-button--prev");
            if (prevButton) prevButton.click();
          }
        }
      });
    }

    isInViewport() {
      const rect = this.getBoundingClientRect();
      return (
        rect.top < window.innerHeight && 
        rect.bottom > 0 && 
        rect.left < window.innerWidth && 
        rect.right > 0  
      );
    }

  }
  customElements.define('hero-slider', HeroSlider);
}
